import { useState } from 'react';

// Store display preferences only; storage may be disabled by the browser.
export function useSessionPreference<T extends string>(
	key: string | undefined,
	fallback: T,
	isValid: (value: string) => boolean
) {
	const [value, setValue] = useState<T>(() => {
		try {
			const saved = key ? sessionStorage.getItem(key) : null;
			return saved !== null && isValid(saved) ? (saved as T) : fallback;
		} catch {
			return fallback;
		}
	});
	const update = (next: T) => {
		setValue(next);
		try {
			if (key) sessionStorage.setItem(key, next);
		} catch {
			// Navigation still works without browser storage.
		}
	};
	return [value, update] as const;
}
